module.exports = __webpack_public_path__ + "media/components/lesson1/statics/inputArea-00a24bb104b2452ebc068ca0c0b6c24b.png";